const KEY = 'gftg:returnTo';

/** Keep a badge scan (or any deep link) across the magic-link sign-in. */
export function rememberReturnTo(pathname: string): void {
  if (pathname.startsWith('/b/')) {
    sessionStorage.setItem(KEY, pathname);
  }
}

export function peekReturnTo(): string {
  const next = sessionStorage.getItem(KEY);
  return next && next.startsWith('/') ? next : '/';
}

export function clearReturnTo(): void {
  sessionStorage.removeItem(KEY);
}
